import * as qs from 'qs';
import { useCallback } from 'react';

import { localStorage } from 'lib/storage/localStorage';

import type { UtmInput } from '../__generated__/globalTypes';
import { Sport } from '../__generated__/globalTypes';

export enum UTM_SOURCES {
  TWITTER = 'twitter',
  WHATSAPP = 'whatsapp',
  FACEBOOK = 'facebook',
}
export enum UTM_CAMPAIGNS {
  LINEUP = 'sharing_lineup',
}
export enum UTM_MEDIUMS {
  SOCIAL = 'social',
}

export function getUtmTermFromSport(sport?: Sport): string {
  switch (sport) {
    case Sport.BASEBALL:
      return 'baseball';
    case Sport.NBA:
      return 'nba';
    default:
    case Sport.FOOTBALL:
      return 'football';
  }
}

type UtmParams = {
  url?: string;
  source?: UTM_SOURCES;
  content?: string;
  medium?: UTM_MEDIUMS;
  campaign?: UTM_CAMPAIGNS;
  term?: string;
  user?: string;
};

export const useUtmParams = () => {
  const getParams = useCallback(() => {
    const campaign = localStorage.getItem('UTM_CAMPAIGN');
    const params: UtmInput = {
      utmCampaign: typeof campaign === 'string' ? campaign : `${campaign}`,
      utmContent: localStorage.getItem('UTM_CONTENT'),
      utmMedium: localStorage.getItem('UTM_MEDIUM'),
      utmSource: localStorage.getItem('UTM_SOURCE'),
      utmTerm: localStorage.getItem('UTM_TERM'),
      trafficCategory: localStorage.getItem('TRAFFIC_CATEGORY'),
      partner: localStorage.getItem('PARTNER'),
      user: localStorage.getItem('USER'),
    };
    return params;
  }, []);

  const setParams = ({
    url,
    source,
    content,
    medium,
    term,
    campaign,
    user,
  }: UtmParams) => {
    if (!url) {
      return '';
    }
    const [baseUrl, queryParams] = url.split('?');
    const parsedQs = qs.parse(queryParams);
    return `${baseUrl}?${qs.stringify({
      ...parsedQs,
      utm_campaign: campaign,
      utm_source: source,
      utm_content: content,
      utm_medium: medium,
      utm_term: term,
      user,
    })}`;
  };

  return { getParams, setParams };
};
